import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const CollectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: ${baseTheme.colors.white};
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
`;

export const OrderTotalBar = styled.div`
  position: sticky;
  top: 64px;
  z-index: 0;
  margin: -20px -20px 0;
  padding: 14px 20px;
  background: ${baseTheme.colors.white};
  border-bottom: 1px solid ${baseTheme.colors.stroking};
  text-align: center;
  font-size: 24px;
  font-weight: 800;
  color: ${baseTheme.colors.primary};
`;

export const StepHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .step-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .step-badge {
    padding: 4px 12px;
    border-radius: 10px;
    background: #dbeafe;
    font-size: 13px;
    font-weight: 700;
    color: ${baseTheme.colors.mainLightBlue};
  }

  .history-button {
    margin-left: auto;
    padding: 6px 14px;
    border-radius: 10px;
    border: 1px solid ${baseTheme.colors.mainLightBlue};
    background: #eff6ff;
    font-size: 13px;
    font-weight: 700;
    color: ${baseTheme.colors.mainLightBlue};
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: #dbeafe;
    }
  }

  .step-title-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }

  .step-title {
    font-size: 20px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
  }

  .products-count {
    font-size: 13px;
    color: ${baseTheme.colors.tertiary};
    white-space: nowrap;
  }
`;

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EmptyTab = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: ${baseTheme.colors.tertiary};

  .empty-text {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .show-all-button {
    padding: 8px 20px;
    border-radius: 10px;
    border: 1px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.white};
    font-size: 14px;
    font-weight: 600;
    color: ${baseTheme.colors.secondary};
    cursor: pointer;
  }
`;

export const CollectFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 6px;
  border-top: 1px solid ${baseTheme.colors.stroking};

  .pending-info {
    font-size: 14px;
    font-weight: 600;
    color: ${baseTheme.colors.secondary};
  }

  .all-collected {
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid #bbf7d0;
    background: #f0fdf4;
    font-size: 14px;
    font-weight: 600;
    color: ${baseTheme.colors.focus};
  }

  .footer-action {
    align-self: flex-end;
    min-width: 240px;
  }
`;
